<div>
  <div>
    <label>
      <span>Date range:</span>
      <input style="cursor: pointer" type="checkbox" (change)="onDateRange($event.currentTarget.checked)" [checked]="false">
    </label>
  </div>

  <div>
    <input angular-mydatepicker class="datePicker" type="hidden" [(ngModel)]="model" [options]="myDatePickerOptions"
      (dateChanged)="onDateChanged($event)" (calendarViewChanged)="onCalendarViewChanged($event)"
      (rangeDateSelection)="onDateRangeSelection($event)" #dp="angular-mydatepicker"/>
  </div>

  <div>
    <button type="button" class="submitButton" (click)="onSubmit()">Submit</button>
    <button type="button" class="submitButton" (click)="dp.clearDate()">Clear</button>
    <button type="button" class="submitButton" (click)="onDisableUntilYesterday()">Disable until yesterday</button>
  </div>

  <div>
    @if (myDatePickerOptions.dateRange) {
      <button type="button" class="submitButton" (click)="onTodayPlus3()">Range today + 3</button>
    }
    @if (myDatePickerOptions.dateRange) {
      <button type="button" class="submitButton" (click)="onYesterdayPlus3()">Range yesterday + 3</button>
    }
  </div>

  <div>
    <button type="button" class="submitButton" (click)="onInitToPastMonth()">Init to past month</button>
  </div>

  <div>
    <!-- header action method calls -->
    <button type="button" class="headerActionButton" (click)="dp.headerAction(1)">Prev</button>
    <button type="button" class="headerActionButton" (click)="dp.headerAction(2)">Next</button>
    <button type="button" class="headerActionButton" (click)="dp.headerAction(3)">Month</button>
    <button type="button" class="headerActionButton" (click)="dp.headerAction(4)">Year</button>
  </div>

</div>

